import { MediaTypeCodeEnum } from '@minecraft.graphql-operations';

export const CLIENT_ALLOWED_FILE_TYPES: { [K in MediaTypeCodeEnum]: string[] } = {
  [MediaTypeCodeEnum.Photo]: ['jpg', 'jpe', 'jpeg', 'png', 'gif'],
  [MediaTypeCodeEnum.Audio]: ['aiff', 'm4a', 'mp3', 'ogg', 'wav'],
  [MediaTypeCodeEnum.Video]: ['mov', 'mkv', 'mp4'],
  [MediaTypeCodeEnum.Document]: ['pdf'],
};

export const MAX_FILE_SIZE_FOR_MEDIA_TYPE: { [K in MediaTypeCodeEnum]: number } = {
  [MediaTypeCodeEnum.Photo]: 1024 ** 2 * 30, // 30MB
  [MediaTypeCodeEnum.Audio]: 1024 ** 2 * 50, // 50MB
  [MediaTypeCodeEnum.Video]: 1024 ** 2 * 600, // 600MB
  [MediaTypeCodeEnum.Document]: 1024 ** 2 * 50, // 50MB
};

export const MIN_IMAGE_DIMENSIONS = {
  WIDTH: 360,
  HEIGHT: 360,
} as const;

export const UPLOAD_STEPS = {
  // this is the initial state where the user can drag & drop, or select files to upload
  SELECT_FILES: 'SELECT_FILES',
  // this is the second step where the user can review the files they've selected
  // and see how it will impact thier storage limit
  REVIEW_FILES: 'REVIEW_FILES',
  // this is when the cloudinary widget is uploading the files
  UPLOAD_WIDGET: 'UPLOAD_WIDGET',
  // this is when the files are being finalized
  FINALIZE_UPLOAD: 'FINALIZE_UPLOAD',
  // this is when the user opens the modal but they are already over their storage limit
  OVER_LIMIT: 'OVER_LIMIT',
} as const;

type StepKeys = keyof typeof UPLOAD_STEPS;

export type StepValuesType = typeof UPLOAD_STEPS[StepKeys];
